import { IntlShape } from "react-intl";

import { ReactComponent as BoltIcon } from "assets/images/icons/Bolt.svg";
import { ReactComponent as CalculatorIcon } from "assets/images/icons/Calculator.svg";
import { ReactComponent as ShipIcon } from "assets/images/icons/Ship.svg";
import { ReactComponent as FileInvoiceDollarIcon } from "assets/images/icons/FileInvoiceDollar.svg";
import ReportType from "../../ReportType";

/**
 * List of report types and their configuration
 */
const REPORT_TYPES = (intl: IntlShape) => [
  {
    type: ReportType.QUICK_REQUEST,
    icon: <BoltIcon />,
    title: intl.formatMessage({
      id: "report.QuickRequest",
      defaultMessage: "Quick Request",
    }),
    description: intl.formatMessage({
      id: "report.QuickRequestStatment",
      defaultMessage: "Each line of the report contains a quick request",
    }),
    enabledForUserTypes: ["shipper"],
  },
  {
    type: ReportType.REQUESTS,
    icon: <BoltIcon />,
    title: intl.formatMessage({
      id: "report.Requests",
      defaultMessage: "Requests",
    }),
    description: intl.formatMessage({
      id: "report.RequestsStatement",
      defaultMessage: "Each line of the report contains a request",
    }),
    enabledForUserTypes: ["shipper"],
  },
  {
    type: ReportType.SHIPMENTS,
    icon: <ShipIcon />,
    title: intl.formatMessage({
      id: "report.Shipments",
      defaultMessage: "Shipments",
    }),
    description: intl.formatMessage({
      id: "report.ShipmentsStatement",
      defaultMessage: "Each line of the report contains a shipment",
    }),
    enabledForUserTypes: ["shipper", "provider"],
  },
  {
    type: ReportType.QUOTES,
    icon: <CalculatorIcon />,
    title: intl.formatMessage({
      id: "report.Quotes",
      defaultMessage: "Quotes",
    }),
    description: intl.formatMessage({
      id: "report.QuotesStatement",
      defaultMessage: "Each line of the report contains a quote",
    }),
    enabledForUserTypes: ["shipper", "provider"],
  },
  {
    type: ReportType.CHARGECODES,
    icon: <CalculatorIcon />,
    title: intl.formatMessage({
      id: "report.ChargeCodes",
      defaultMessage: "Charge Codes",
    }),
    description: intl.formatMessage({
      id: "report.ChargeCodesStatment",
      defaultMessage: "Each line of the report contains a charge code",
    }),
    enabledForUserTypes: ["shipper"],
  },
  {
    type: ReportType.INVOICES,
    icon: <FileInvoiceDollarIcon />,
    title: intl.formatMessage({
      id: "report.Invoices",
      defaultMessage: "Invoices",
    }),
    description: intl.formatMessage({
      id: "report.InvoicesStatement",
      defaultMessage: "Each line of the report contains an invoice",
    }),
    enabledForUserTypes: ["shipper", "provider"],
  },
];

export default REPORT_TYPES;
